export const displayDeckConfig = {
  SINGLE_CARD: "SINGLE_CARD",
};
